export default class Accordion {
    constructor(accordionElement, globalToggle = false) {
        this.accordion = accordionElement;
        this.globalToggle = globalToggle;
        this.triggers = this.accordion.querySelectorAll('[data-accordion="trigger"]');

        this.init();
    }

    init() {
        this.triggers.forEach(trigger => {
            trigger.addEventListener("click", (event) => this.toggleItem(event.currentTarget));
        });
    }

    toggleItem(trigger) {
        const isExpanded = trigger.getAttribute("aria-expanded") === "true",
            targetContent = this.accordion.querySelector(`[data-accordion-target="${trigger.getAttribute("data-accordion-trigger")}"]`);

        // Close all other items if globalToggle is enabled
        if (this.globalToggle) {
            this.triggers.forEach(otherTrigger => {
                if (otherTrigger !== trigger) {
                    const otherContent = this.accordion.querySelector(`[data-accordion-target="${otherTrigger.getAttribute("data-accordion-trigger")}"]`);

                    // Remove open attribute and set aria-expanded and aria-hidden
                    otherTrigger.removeAttribute("open");
                    otherTrigger.setAttribute("aria-expanded", "false");
                    otherContent.setAttribute("aria-hidden", "true");
                }
            });
        }

        trigger.setAttribute("aria-expanded", !isExpanded);
        targetContent.setAttribute("aria-hidden", isExpanded);
    }
}